import { Link } from 'react-router-dom';

import { IconButton, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './style.module.css';

const CustomLink = ({
    icon: Icon,
    linkText,
    link,
    variant,
    customLinkStyle,
    customLinkTextStyle,
    iconStyle,
    endIcon: EndIcon,
    endIconStyle,
    external = false,
    ...props
}) => {
    const isPassive = props?.disabled || props?.isOnClickHandler;

    const getLinkProps = () => {
        if (isPassive) return {};
        if (external) return { href: link, target: '_blank', rel: 'noopener noreferrer' };
        return { to: link };
    };

    const getComponentType = () => {
        if (isPassive) return 'span';
        if (external) return 'a';
        return Link;
    };

    const linkProps = getLinkProps();
    const component = getComponentType();

    return (
        <IconButton
            component={component}
            className={clsx(
                styles.link,
                {
                    [styles.filled]: variant === 'filled',
                    [styles.outlined]: variant === 'outlined',
                },
                customLinkStyle
            )}
            {...linkProps}
            {...props}
        >
            {Icon && <Icon className={clsx(styles.icon, iconStyle)} />}
            <Typography className={clsx(styles.linkText, customLinkTextStyle)}>
                {linkText}
            </Typography>
            {EndIcon && <EndIcon className={clsx(styles.endIcon, endIconStyle)} />}
        </IconButton>
    );
};

CustomLink.propTypes = {
    icon: PropTypes.elementType,
    linkText: PropTypes.string,
    link: PropTypes.string,
    variant: PropTypes.oneOf(['filled', 'outlined']),
    customLinkStyle: PropTypes.string,
    customLinkTextStyle: PropTypes.string,
    iconStyle: PropTypes.string,
    endIcon: PropTypes.elementType,
    endIconStyle: PropTypes.string,
    external: PropTypes.bool,
    disabled: PropTypes.bool,
    isOnClickHandler: PropTypes.bool,
};

export default CustomLink;
